import React from 'react'
import { Col, Button } from 'react-bootstrap'

const MessagingButton = ({
    onClick = () => {},
    children,
    active
}) => {
    const borderBottom = active ? '4px solid rgb(48, 155, 248)' : undefined
    return (
        <Col className='text-center' style={{ paddingBottom: '20px', borderBottom }}>
            <Button variant='link' block active={active} onClick={() => onClick()}>{children}</Button>
        </Col>
    )
}

export default MessagingButton